import type { ImgHTMLAttributes } from "react";

// Keep in sync with WIDTHS in scripts/optimize-images.mjs.
const WIDTHS = [480, 640, 960, 1600];
const PHOTO = /^\/images\/(?!blog\/)(.+)\.(jpe?g|png)$/i;

/** srcset of the WebP renditions for a /images/ photo (see scripts/optimize-images.mjs). */
export const webpSrcSet = (src: string) => {
  const m = PHOTO.exec(src);
  return m ? WIDTHS.map((w) => `/img/${m[1]}-${w}.webp ${w}w`).join(", ") : undefined;
};

/** <img> that serves phones a right-sized WebP instead of the full original.
 *  `sizes` says how wide the image renders; default is full width. The original
 *  stays in `src` as the fallback. Non-/images/ sources pass through unchanged. */
const Img = ({ src = "", sizes = "100vw", ...rest }: ImgHTMLAttributes<HTMLImageElement>) => {
  const srcSet = webpSrcSet(src);
  return <img src={src} srcSet={srcSet} sizes={srcSet ? sizes : undefined} {...rest} />;
};

export default Img;
